function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11 5.5H9.5v2H11v-2zM8 5.5H6.5v2H8v-2zM11 9H9.5v2H11V9zM8 9H6.5v2H8V9zM11 12.5H9.5v2H11v-2zM8 12.5H6.5v2H8v-2zM11 16H9.5v2H11v-2zM8 16H6.5v2H8v-2z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 2.5H5c-.8 0-1.5.7-1.5 1.5v16H2v1.5h20V20h-1.5v-6.5c0-.8-.7-1.5-1.5-1.5h-5V4c0-.8-.7-1.5-1.5-1.5zM5 20V4h7.5v9.5H19V20h-3.3v-3h-1.5v3H5z",
  fill: "currentColor"
});

function SvgBuildingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgBuildingIcon;